var loaders = require('../layout/components/loaders');
var io = require('../libs/socketio');
var agentGatewayStatus = require('./agentGatewayStatus');

var state = { updatedAt: null, workers: [] };
var statusByRid = Object.create(null);
var listeners = [];
var requestPromise = null;
var socketAttached = false;

function sortWorkers(workers) {
  return (workers || []).slice().sort(function (a, b) {
    return Number(a && a.workerId) - Number(b && b.workerId);
  });
}

function rebuildStatusIndex() {
  statusByRid = agentGatewayStatus.indexByGatewayRid(state.workers);
}

function notify() {
  listeners.slice().forEach(function (listener) {
    listener(state);
  });
}

function setState(nextState) {
  state = {
    updatedAt: nextState && nextState.updatedAt ? nextState.updatedAt : Date.now(),
    workers: sortWorkers(nextState && nextState.workers)
  };
  rebuildStatusIndex();
  notify();
  return state;
}

function applyWorkerUpdate(payload) {
  if (!payload || typeof payload.workerId === 'undefined' || payload.workerId === null) return;

  var workers = (state.workers || []).slice();
  var idx = workers.findIndex(function (worker) {
    return worker && Number(worker.workerId) === Number(payload.workerId);
  });

  if (idx >= 0) workers[idx] = payload;
  else workers.push(payload);

  setState({
    updatedAt: Date.now(),
    workers: workers
  });
}

function ensureSocket() {
  if (socketAttached) return;
  io.on('agent-metrics', applyWorkerUpdate);
  socketAttached = true;
}

function releaseSocketIfIdle() {
  if (!socketAttached || listeners.length > 0) return;
  io.off('agent-metrics', applyWorkerUpdate);
  socketAttached = false;
}

function refresh() {
  if (requestPromise) return requestPromise;

  requestPromise = loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/agent/metrics',
    method: 'GET',
  })
  .then(function (res) {
    return setState({
      updatedAt: res && res.updatedAt,
      workers: res && Array.isArray(res.workers) ? res.workers : []
    });
  });

  requestPromise.then(function () {
    requestPromise = null;
  }, function () {
    requestPromise = null;
  });

  return requestPromise;
}

function subscribe(listener) {
  if (typeof listener === 'function') listeners.push(listener);
  ensureSocket();
  refresh().catch(function (err) {
    console.error('Failed to load agent metrics for host statuses', err);
  });

  return function unsubscribe() {
    var idx = listeners.indexOf(listener);
    if (idx >= 0) listeners.splice(idx, 1);
    releaseSocketIfIdle();
  };
}

function statusForRecord(record) {
  return agentGatewayStatus.statusForRecord(record, statusByRid);
}

module.exports = {
  refresh: refresh,
  subscribe: subscribe,
  statusClass: agentGatewayStatus.statusClass,
  statusForRecord: statusForRecord,
  statusRank: agentGatewayStatus.statusRank,
  _private: {
    applyWorkerUpdate: applyWorkerUpdate,
    getState: function () { return state; },
    setState: setState
  }
};
